import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { AdminShell } from "@/components/admin/admin-shell";
import { OrderManager } from "@/components/admin/order-manager";
import { apiGet } from "@/services/api";
import type { Order, OrderItem } from "@/types/prisma";

type AdminOrder = Order & {
  items: OrderItem[];
  user: { name: string | null; email: string } | null;
};

/** `app/admin/orders/page.tsx`. */
export function AdminOrdersPage() {
  const [orders, setOrders] = useState<AdminOrder[]>([]);
  const location = useLocation();
  const scope = location.pathname.startsWith("/admin1") ? "admin1" : "admin";

  useEffect(() => {
    let active = true;
    void apiGet<{ orders: AdminOrder[] }>(`/api/admin/orders?scope=${scope}`).then((data) => {
      if (active) setOrders(data?.orders ?? []);
    });
    return () => {
      active = false;
    };
  }, [scope]);

  return (
    <AdminShell title="Orders">
      <OrderManager initialOrders={orders} />
    </AdminShell>
  );
}
